/**
 * How far a driver is from the pickup of an offer (DRV-009): a traffic light for the offer card.
 * By time, not distance: in the Oriente antioqueño 8 km of mountain road can be 20 minutes. Without a
 * time (the router fell back), the distance is turned into one at a slow urban speed.
 */
export type OfferProximity = 'near' | 'mid' | 'far';

export const OFFER_PROXIMITY = {
  /** up to this many seconds to the pickup: near */
  nearS: 7 * 60,
  /** more than this: far (asked to confirm before accepting) */
  farS: 12 * 60,
  /** m/s used when only the distance is known (~25 km/h) */
  fallbackSpeedMps: 7,
} as const;

/** null when neither the time nor the distance to the pickup is known. */
export function offerProximity(etaS: number | null | undefined, distanceM: number | null | undefined): OfferProximity | null {
  const s = typeof etaS === 'number' && Number.isFinite(etaS) ? etaS : typeof distanceM === 'number' && Number.isFinite(distanceM) ? distanceM / OFFER_PROXIMITY.fallbackSpeedMps : null;
  if (s === null || s < 0) return null;
  if (s <= OFFER_PROXIMITY.nearS) return 'near';
  return s > OFFER_PROXIMITY.farS ? 'far' : 'mid';
}
